<template>
  <div class="fieldset">
    <template v-if="form">
      <h3 class="fieldset-heading">Gifts</h3>

      <!-- Do you want to change any gifts? -->
      <GiftsYN v-model="form.giftsYN"/>
      <Gifts v-if="form.giftsYN" v-model="form.gifts"/>
    </template>
  </div>
</template>

<script>
import {fieldsetHelpers} from "@/components/common/questionnaires/fieldsets/fieldsetHelpers";
import {statusOptions} from "@/components/common/questionnaires/question/options/statusOptions";
import {personalDetails} from "@/components/common/questionnaires/question/options/personalDetails";

import GiftsYN from "@/components/common/questionnaires/question/questions/amendment/GiftsYN.vue";
import Gifts from "@/components/common/questionnaires/question/questions/amendment/Gifts.vue";

export default {
  name: 'GiftsAmendment',
  mixins: [fieldsetHelpers, statusOptions, personalDetails],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  components: {
    GiftsYN,
    Gifts,
  },
  data() {
    return {
      label: 'Gifts', // used for steps progress
      videoUrl: null
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        console.log('HERE---b---', this.value);
        return this.value
      }
    }
  }
};
</script>
